export default __webpack_public_path__ + "static/media/sticker-by.d9ebb41c.png";